var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.266667,
    y: 0.266667,
    width: 31.4667,
    height: 31.4667,
    rx: 7.73333,
    stroke: "#6B6084",
    strokeWidth: 0.533333
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_1620)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 24H20.8V18.4008C20.8 16.8648 20.1224 16.0078 18.9072 16.0078C17.5848 16.0078 16.8 16.9008 16.8 18.4008V24H13.6V13.6H16.8V14.7695C16.8 14.7695 17.804 13.0078 20.0664 13.0078C22.3296 13.0078 24 14.3889 24 17.2465V24ZM9.9536 11.9367C8.8744 11.9367 8 11.0552 8 9.96797C8 8.88157 8.8744 8 9.9536 8C11.032 8 11.9064 8.88157 11.9064 9.96797C11.9072 11.0552 11.032 11.9367 9.9536 11.9367ZM8 24H12V13.6H8V24Z",
    fill: "#6B6084"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_1620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIcon);
export default __webpack_public_path__ + "static/media/LinkedIcon.60392c8979b022fa57627e5d77f416be.svg";
export { ForwardRef as ReactComponent };